import { combineReducers } from "redux";
import leadDashboard from "./reducer/leadDashboad";
import LeadDBSummary from "./reducer/LeadDBSummary";
import leadView from "./reducer/LeadView";
import EmployeeList from "./reducer/EmployeeList";
import createNamedWrapperReducer from "@redux/feature/Markets/Equity/wrapperReducer";
import ClientProfileDetails from "./reducer/ClientProfileDetails";
import AddEditPastIntraction from "./reducer/AddEditLeadPastIntraction";
import ViewLeadData from "./reducer/ViewLeadData";
import PurchaseHistory from "./reducer/PurchaseHistory";
export default combineReducers({
    LeadDashboard: createNamedWrapperReducer(leadDashboard, "LeadDashboard"),
    LeadDBSummary: LeadDBSummary,
    leadView: leadView,
    EmployeeList: EmployeeList,
    PurchaseHistory: createNamedWrapperReducer(PurchaseHistory, "PurchaseHistory"),
    ClientProfileDetails: createNamedWrapperReducer(ClientProfileDetails, "ClientProfileDetails"),
    PastIntraction: createNamedWrapperReducer(AddEditPastIntraction, "PastIntraction"),
    ViewLead: createNamedWrapperReducer(ViewLeadData, "ViewLead"),
});
